import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/lib/services/settings';
import { useAuth } from '@/contexts/AuthContext';
import { useRoleDetection } from '@/hooks/useRoleDetection';
import { isAnyAdmin } from '@/utils/adminUtils';
import { canAccessDevelopmentPlans } from '@/utils/developmentPlanAccess';

/**
 * Resolves whether the current user may access the leadership Development
 * Plans page for their store. `isLoading` is true until settings have
 * resolved — callers gating navigation/redirects should wait for it to
 * avoid a flash.
 */
export function useCanAccessDevelopmentPlans(): { canAccess: boolean; isLoading: boolean } {
  const { user } = useAuth();
  const { isDirector } = useRoleDetection();
  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
  });

  const developmentPlansDirectorOnly =
    !!settings?.userAccess?.leadership?.developmentPlansDirectorOnly;

  const canAccess = canAccessDevelopmentPlans({
    isAdmin: isAnyAdmin(user),
    isDirector,
    developmentPlansDirectorOnly,
  });

  return { canAccess, isLoading };
}
